module.exports = "/_next/static/images/OgEvents-0f44a19596f6d10c95522cae6af7d52f.jpg";